export const Columns = {
    SOLD_DATE: 'SOLD_DATE',
    BUYER: 'BUYER',
    ORDER_ID: 'ORDER_ID',
    ORDER: 'ORDER',
    QUANTITY: 'QUANTITY',
    BUYING_PRICE: 'BUYING_PRICE',
    PAYMENT_TYPE: 'PAYMENT_TYPE',
    LANGUAGE: 'LANGUAGE',
    STATUS: 'STATUS',
    ACTIONS: 'ACTIONS'
};
